import { FC } from 'react';
import { format } from 'date-fns';
import { Edit, Trash2 } from 'lucide-react';
import { DropdownMenuItem, DropdownMenuSeparator } from "@/components/ui/dropdown-menu";
import { BaseEventCard, EventActionsMenu } from './BaseEventCard';
import { CapacityIndicator } from './CapacityIndicator';

interface RegularActivityCardProps {
  title: string;
  capacity: number;
  booked: number;
  start?: Date | string | null | undefined;
  end?: Date | string | null | undefined;
  isMonthView: boolean;
  isMenuOpen: boolean;
  onMenuOpenChange: (open: boolean) => void;
  onEdit: () => void;
  onDelete: () => void;
  onMouseEnter?: (e: React.MouseEvent) => void;
  onMouseLeave?: () => void;
  children?: React.ReactNode; // For hover card
}

export const RegularActivityCard: FC<RegularActivityCardProps> = ({
  title,
  capacity,
  booked,
  start,
  end,
  isMonthView,
  isMenuOpen,
  onMenuOpenChange,
  onEdit,
  onDelete,
  onMouseEnter,
  onMouseLeave,
  children
}) => {
  // Format time display for week/day views
  const timeDisplay = (!isMonthView && start && end) ? (
    <div className="text-xs text-white/90 truncate ml-auto font-medium">
      {format(new Date(start), 'HH:mm')} - {format(new Date(end), 'HH:mm')}
    </div>
  ) : null;

  return (
    <BaseEventCard
      theme="regular"
      isMonthView={isMonthView}
      onMouseEnter={onMouseEnter}
      onMouseLeave={onMouseLeave}
      title={title}
      actionsMenu={
        <EventActionsMenu
          theme="regular"
          isOpen={isMenuOpen}
          onOpenChange={onMenuOpenChange}
        >
          <DropdownMenuItem onClick={onEdit} className="flex items-center gap-2">
            <Edit className="h-4 w-4" />
            Edit Slot
          </DropdownMenuItem>
          <DropdownMenuSeparator />
          <DropdownMenuItem 
            onClick={onDelete} 
            className="flex items-center gap-2 text-red-600 focus:text-red-600"
          >
            <Trash2 className="h-4 w-4" />
            Delete Slot
          </DropdownMenuItem>
        </EventActionsMenu>
      }
      leftContent={
        <CapacityIndicator 
          booked={booked} 
          capacity={capacity}
          size="xs"
          showNumbers={true}
        />
      }
      rightContent={timeDisplay}
    >
      {children}
    </BaseEventCard>
  );
};
